import { VUE_UNION_STATION } from "@/assets/js/stationSetting";
import { toPublicLocale } from "@/assets/js/routeSeo";

export default function(language, path) {
  const publicLocale = toPublicLocale(language);
  if (publicLocale == "en" && VUE_UNION_STATION == "8V") {
    return `/${path}`;
  }
  return `/${path}/${publicLocale}`;
}
